module.exports = __webpack_public_path__ + "static/media/brasao.4e389b33.png";